import { IDocument } from './document.model.interface';
import { DocumentOrigin, DocumentType } from './enums/document.enum';

export class Document implements IDocument {
  readonly documentId: string;
  readonly name: string;
  readonly type: DocumentType;
  readonly mimeType: string;
  readonly date: Date;
  origin: DocumentOrigin | null;

  constructor(data: IDocument) {
    this.documentId = data.documentId;
    this.name = data.name;
    this.type = data.type;
    this.mimeType = data.mimeType;
    this.date = data.date; // Create a new Object to make sure it is immutable
    this.origin = data.origin;
  }

  // Puedes agregar métodos adicionales aquí si es necesario
}
